import { FC } from 'react'
import {
    Outlet
} from "react-router-dom";


const AmortizmentPage: FC = () => {  
    return (
        <Outlet />
    );
}

export default AmortizmentPage